import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');
var serviceName = "index";
var projeService = {
    path : "https://www.sidasas.com.tr/",
    tanimlama(kategori,link, baslik, altBaslik, icerik, seoBaslik, seoIcerik, belgeList, resimList, resimKonum, menuKonum, galeriKonum, url,baslamaTarihi,
              bitisTarihi, durum) {
        var userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
        console.log(belgeList);
        var param = {
            data: {
                yonetimId: userDataSidas["yonetimId"],
                userToken: userDataSidas["token"],
                firmaKodu: userDataSidas["firmaKodu"],
                link: link,
                kategori: kategori,
                baslik: baslik,
                altBaslik: altBaslik,
                icerik: icerik,
                seoBaslik: seoBaslik,
                seoIcerik: seoIcerik,
                belgeList: belgeList,
                resimList: resimList,
                resimKonum: resimKonum,
                menuKonum: menuKonum,
                galeriKonum: galeriKonum,
                url: url,
                baslamaTarihi: baslamaTarihi,
                bitisTarihi: bitisTarihi,
                durum: durum,
                dil: [],
                serviceName:"proje",
                methodName: "projeTanimlama"
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },

    projeDetay(projeKodu) {
        var userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
        var param = {
            data: {
                yonetimId: userDataSidas["yonetimId"],
                userToken: userDataSidas["token"],
                firmaKodu: userDataSidas["firmaKodu"],
                projeKodu: projeKodu,
                serviceName:"proje",
                methodName: "projeDetay"

            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    projeCount(durum) {
        var userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
        var param = {
            data: {
                yonetimId: userDataSidas["yonetimId"],
                userToken: userDataSidas["token"],
                firmaKodu: userDataSidas["firmaKodu"],
                durum: durum,
                serviceName:"proje",
                methodName: "projeCount"

            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },

    projeListDetay(kategoriKodu, baslangic, limit, durum) {
        var userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
        var param = {
            data: {
                yonetimId: userDataSidas["yonetimId"],
                userToken: userDataSidas["token"],
                firmaKodu: userDataSidas["firmaKodu"],
                kategoriKodu: kategoriKodu,
                baslangic: baslangic,
                limit: limit,
                durum: durum,
                dil: "",
                serviceName:"proje",
                methodName: "projeList"

            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    projeDurumGuncelle(projeKodu, durum) {
        var userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
        var param = {
            data: {
                yonetimId: userDataSidas["yonetimId"],
                userToken: userDataSidas["token"],
                firmaKodu: userDataSidas["firmaKodu"],
                projeKodu: projeKodu,
                durum: durum,
                serviceName:"proje",
                methodName: "projeDurumGuncelle"

            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    projeGuncelleme(projeKodu, updateList) {
        var userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
        var param = {
            data: {
                yonetimId: userDataSidas["yonetimId"],
                userToken: userDataSidas["token"],
                firmaKodu: userDataSidas["firmaKodu"],
                projeKodu: projeKodu,
                updateList: updateList,
                serviceName:"proje",
                methodName: "projeGuncelle"

            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },


};
export default projeService